import React from 'react';
import PropTypes from 'prop-types';
import { PRODUCT_IDS } from '@adsk/alloy-provider';
import { FLAG_NAMES } from '@common/flagNames';
import {
  withAdminFFs,
  useAdminFeatureFlag,
} from '@common/AdminLaunchDarklyProvider';
import { StoreProvider } from '@common/helpers/storeProvider';
import useProjectSettings from './hooks/useProjectSettings';
import Content from './Content';
import CategorizedContent from './CategorizedContent';
import {
  initialState,
  init,
  reducer,
} from './CategorizedContent/store/reducer';
import { CategorizedContentStoreContext } from './constants';

const {
  ADMIN_FLAGS: { ACC_REPLACE_GET_CONSTRUCTION_APIS, SHOW_CATEGORIZED_SETTINGS },
} = FLAG_NAMES;
const { PROJECT_ADMINISTRATION } = PRODUCT_IDS;

const ProjectTabContentContainer = ({ onProfileSave }) => {
  // Load Admin FFs
  const {
    loading: loadingCategorizedSettingsFF,
    value: showCategorizedSettings,
  } = useAdminFeatureFlag(SHOW_CATEGORIZED_SETTINGS);
  const {
    loading: loadingUseGetConstructionApis,
    value: useGetConstructionApis,
  } = useAdminFeatureFlag(ACC_REPLACE_GET_CONSTRUCTION_APIS);

  const { adminAccessProducts, productId, projectUserAccess } =
    useProjectSettings(useGetConstructionApis);
  const isProjectAdminProduct = productId === PROJECT_ADMINISTRATION;
  const showInProductSettings =
    isProjectAdminProduct && adminAccessProducts?.length > 0;
  // Determine whether data is editable or not for the user
  const isProjectAdmin = projectUserAccess?.projectAdministrator;
  const isAccountAdmin = projectUserAccess?.accountAdministrator;
  const isAdminUser = isProjectAdmin || isAccountAdmin;
  const loading = loadingUseGetConstructionApis || loadingCategorizedSettingsFF;

  return showCategorizedSettings ? (
    // ACSPA-1519: [UI Update] ACC Settings Project Profile View State
    <StoreProvider
      storeContext={CategorizedContentStoreContext}
      reducer={reducer}
      initialState={initialState}
      init={init}
    >
      <CategorizedContent
        isAdminUser={isAdminUser}
        loading={loading}
        onProfileSave={onProfileSave}
        showInProductSettings={showInProductSettings}
        showInformationBanner={!isProjectAdminProduct}
        useGetConstructionApis={useGetConstructionApis}
      />
    </StoreProvider>
  ) : (
    // Keep old view state
    <Content
      isAdminUser={isAdminUser}
      loading={loading}
      onProfileSave={onProfileSave}
      showInProductSettings={showInProductSettings}
      useGetConstructionApis={useGetConstructionApis}
    />
  );
};

ProjectTabContentContainer.propTypes = {
  onProfileSave: PropTypes.func.isRequired,
};

export default withAdminFFs(ProjectTabContentContainer);
